import { Typography } from '@design-system/components/typography/typography';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const InfoAlert = ({ text }: { text: string }) => (
  <div className="flex gap-2 bg-[#E5F6FD] text-black px-[16px] py-[14px] rounded-[10px]">
    <FontAwesomeIcon icon={faInfoCircle} className="text-[#448AF7] pt-[3px]" />
    <Typography>{text}</Typography>
  </div>
);
